import axios from "../../axios";

export const GetAllLeads = async () => {
	const res = await axios.post("/api/Leads/GetAllLeadsByVLE", {});
	return res.data;
};
